import { LayoutWrapper, HeaderWrapper, ContentWrapper } from './styled-components';

export type Props = {
  header: React.ReactNode;
  content: React.ReactNode;
  className?: string;
};

export const EmployerCardLayout = ({ header, content, className }: Props) => (
  <LayoutWrapper className={className} data-testid="employer-card-layout">
    <HeaderWrapper>{header}</HeaderWrapper>
    <ContentWrapper>{content}</ContentWrapper>
  </LayoutWrapper>
);
